import { render, staticRenderFns } from "./ContentStudentStatsTable.vue?vue&type=template&id=7737cf64"
import script from "./ContentStudentStatsTable.vue?vue&type=script&lang=js"
export * from "./ContentStudentStatsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports